// extracted by mini-css-extract-plugin
export default {"container":"jMl6RDn35fZ_XZPNFCPi","modal":"Y4yWf_Qn6WXCn0OVze8O","head":"SRTpmJHEAb6bGtDLlBof","body":"ISzJvthAqfNn0x9xUq5L"};